import { Vertical } from '@/types/verticals'
import fishRoutes from '@/fish/router/constants'

type NavRoutes = {
  [Vertical.Fish]: {
    ACCOUNT: string
    SETTINGS: string
  }
}

type RouteEvents = {
  [key: string]: string
}

type NavEvents = {
  [Vertical.Fish]: RouteEvents
}

export const NAV_ROUTES: NavRoutes = {
  [Vertical.Fish]: {
    ACCOUNT: fishRoutes.ACCOUNT_FISH,
    SETTINGS: fishRoutes.SETTINGS_FISH,
  },
}

export const NAV_EVENTS: NavEvents = {
  [Vertical.Fish]: {
    [fishRoutes.MY_CONTENT_CARD_FISH]: 'my_content_opened',
    [fishRoutes.FAVORITES_FISH]: 'favorites_opened',
    [fishRoutes.ACCOUNT_FISH]: 'viewed_my_account',
    [fishRoutes.SETTINGS_FISH]: 'viewed_map_settings',
  },
}
